<template>
  <div>
    <el-button class="traffic_info" :class="{'is-planning': trafficInfoLoading}" :disabled="trafficInfoLoading" @click="getTrafficInfo">
      <span v-if="trafficInfoLoading" class="planning-content">
        <i class="iconfont icon-airplane planning-plane"></i>
        <span class="planning-track"><i></i><i></i><i></i></span>
        <span>路线规划中</span>
      </span>
      <span v-else style="display: flex;align-items: center;column-gap: 3px">
        <i class="iconfont icon-ai-sparkle-icon-iconfont1" style="font-size: 14px;"/>
        <span>交通信息推荐</span>
      </span>
    </el-button>
    <el-dialog title="交通信息推荐" :visible.sync="dialogVisible" width="720px" custom-class="traffic-info-dialog" :close-on-click-modal="false">
      <template slot="title">
        <div class="dialog-title">交通信息推荐</div>
      </template>

      <div class="hotel-tip">前往酒店：{{ $commonUtil.getCnStr(hotelInfo.nameCn, hotelInfo.nameEn) }}</div>
      <div class="route-list">
        <div v-for="(route, index) in routes" :key="route.name" class="route-item">
          <div class="route-type">
            <i v-if="route.icon === 'airplane'" class="iconfont icon-airplane route-icon"></i>
            <span v-else class="train-icon" aria-hidden="true"><span class="train-window"></span></span>
            <div class="type-tag">{{ route.origin_type }}</div>
          </div>
          <div class="route-detail">
            <div class="route-name">{{ route.origin_name }}</div>
            <div class="field-label summary-label">交通线路概括</div>
            <div class="route-summary">{{ route.route_summary }}</div>
          </div>
          <div v-if="index !== routes.length - 1" class="route-divider"></div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <div class="notice"><i class="el-icon-info"></i><span>以上信息由科坦整理推荐，仅供参考</span></div>
        <el-button type="primary" @click="dialogVisible = false">我知道了</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'TrafficInfoDialog',
  props: ['hotelInfo'],
  data () {
    return {
      dialogVisible: false,
      trafficInfoLoading: false,
      routes: []
    }
  },
  methods: {
    async getTrafficInfo () {
      if (this.trafficInfoLoading) return

      this.trafficInfoLoading = true
      try {
        let partnerInfo = JSON.parse(localStorage.getItem('partnerInfo')) || {}
        let reqHeader = {
          accessToken: partnerInfo.token
        }
        const {data: result} = await this.$http.get(`/mini/getTrafficInfo?sHotelId=${this.hotelInfo.hotelId}`, {headers: reqHeader})
        if (result.code !== 200) {
          this.$message.error(result.message)
          return
        }
        if (!result.data || !result.data.routes || !result.data.routes.length) return this.$message.warning('未找到相关交通信息')
        this.routes = result.data.routes
        this.routes.forEach(route => {
          if (route['origin_type'] === '机场') {
            route.icon = 'airplane'
          } else if (route['origin_type'] === '高铁站') {
            route.icon = 'train'
          }
        })
        this.routes = this.routes.filter(item => item.origin_name)
        this.dialogVisible = true
      } catch (error) {
        this.$message.error('交通信息获取失败，请稍后重试')
      } finally {
        this.trafficInfoLoading = false
      }
    }
  }
}
</script>

<style scoped lang="less">
.dialog-title { color: #20242c; font-size: 20px; font-weight: 600; line-height: 28px; }
.dialog-subtitle { margin-top: 2px; color: #8a8f99; font-size: 14px; line-height: 20px; }
.hotel-tip { box-sizing: border-box; width: 100%; padding: 10px 14px; border-radius: 6px; background: #e8f2ff; color: #2878f0; font-size: 15px; font-weight: 600; line-height: 20px; }
.route-item { position: relative; display: flex; padding: 28px 0; }
.route-type { flex: 0 0 96px; box-sizing: border-box; border-right: 1px solid #e5e8ed; text-align: center; }
.route-icon { display: block; margin: 1px auto 10px; color: #246df5; font-size: 31px; line-height: 34px; transform: rotate(-8deg); }
.train-icon { position: relative; display: block; box-sizing: border-box; width: 27px; height: 31px; margin: 1px auto 13px; border: 3px solid #246df5; border-radius: 5px 5px 7px 7px; }
.train-icon::before, .train-icon::after { position: absolute; bottom: -7px; width: 5px; height: 5px; border-radius: 50%; background: #246df5; content: ''; }
.train-icon::before { left: 2px; }
.train-icon::after { right: 2px; }
.train-window { position: absolute; top: 5px; left: 4px; width: 13px; height: 7px; border-radius: 1px; background: #246df5; }
.type-label, .field-label { color: #7f8590; font-size: 13px; line-height: 18px; }
.type-tag { display: inline-block; margin-top: 6px; padding: 3px 9px; border-radius: 4px; background: #e8f2ff; color: #2878f0; font-size: 14px; font-weight: 600; line-height: 20px; }
.route-detail { min-width: 0; flex: 1; padding-left: 24px; }
.route-name { margin-top: 1px; color: #20242c; font-size: 18px; font-weight: 600; line-height: 25px; }
.summary-label { margin-top: 7px; }
.route-summary { color: #3d424b; font-size: 14px; line-height: 22px; }
.route-divider { position: absolute; right: 0; bottom: 0; left: 0; height: 1px; background: #e9ebef; }
.dialog-footer { display: flex; align-items: center; justify-content: space-between; width: 100%; }
.notice { display: flex; align-items: center; min-width: 0; color: #8a8f99; font-size: 13px; text-align: left; }
.notice i { margin-right: 7px; font-size: 15px; }
/deep/ .traffic-info-dialog { overflow: hidden; border-radius: 8px; }
/deep/ .traffic-info-dialog .el-dialog__header {
  position: relative;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  height: auto !important;
  padding: 22px 28px 18px !important;
  background: #fff !important;
}
/deep/ .traffic-info-dialog .el-dialog__headerbtn {
  top: 50%;
  right: 24px;
  font-size: 24px;
  line-height: 1;
  transform: translateY(-50%);
}
/deep/ .traffic-info-dialog .el-dialog__headerbtn .el-dialog__close { color: #60656f; }
/deep/ .traffic-info-dialog .el-dialog__body { padding: 0 28px; }
/deep/ .traffic-info-dialog .el-dialog__footer { padding: 17px 28px; border-top: 1px solid #e9ebef; }
/deep/ .traffic-info-dialog .el-button--primary { min-width: 100px; padding: 10px 18px; border-color: #195cf4; border-radius: 6px; background: #195cf4; font-size: 14px; }

@media (max-width: 760px) {
  /deep/ .traffic-info-dialog { width: calc(100% - 24px) !important; }
  /deep/ .traffic-info-dialog .el-dialog__header, /deep/ .traffic-info-dialog .el-dialog__body, /deep/ .traffic-info-dialog .el-dialog__footer { padding-right: 16px; padding-left: 16px; }
  .route-type { flex-basis: 72px; }
  .route-detail { padding-left: 14px; }
  .dialog-footer { align-items: flex-end; }
  .notice { margin-right: 12px; }
}


.traffic_info {
  box-sizing: border-box;
  min-width: 124px;
  height: 40px;
  padding: 8px 15px;
  border: 1px solid #163ffc;
  border-radius: 4px;
  background: #fff;
  color: #163ffc;
  font-size: 14px;
  user-select: none;
  cursor: pointer;
}

.traffic_info:hover,
.traffic_info:focus {
  border-color: #163ffc;
  background: #f2f6ff;
  color: #163ffc;
}

.traffic_info.is-planning,
.traffic_info.is-planning:hover,
.traffic_info.is-planning:focus {
  position: relative;
  overflow: hidden;
  border-color: #8eacff;
  background: #edf3ff;
  color: #163ffc;
  cursor: wait;
  opacity: 1;
}

.traffic_info.is-planning::after {
  position: absolute;
  top: 0;
  bottom: 0;
  left: -45%;
  width: 35%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, .85), transparent);
  content: '';
  animation: traffic-shimmer 1.4s ease-in-out infinite;
}

.planning-content {
  position: relative;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.planning-plane {
  margin-right: 5px;
  font-size: 17px;
  animation: plane-fly 1.2s ease-in-out infinite;
}

.planning-track {
  display: inline-flex;
  align-items: center;
  margin-right: 7px;
}

.planning-track i {
  width: 3px;
  height: 3px;
  margin-left: 3px;
  border-radius: 50%;
  background: #7697f8;
  animation: track-pulse 1.2s ease-in-out infinite;
}

.planning-track i:nth-child(2) { animation-delay: .15s; }
.planning-track i:nth-child(3) { animation-delay: .3s; }

@keyframes plane-fly {
  0%, 100% { transform: translate(-1px, 1px) rotate(-8deg); }
  50% { transform: translate(2px, -2px) rotate(-8deg); }
}

@keyframes track-pulse {
  0%, 100% { opacity: .3; transform: scale(.75); }
  50% { opacity: 1; transform: scale(1.25); }
}

@keyframes traffic-shimmer {
  from { left: -45%; }
  to { left: 115%; }
}
</style>



// WEBPACK FOOTER //
// src/pages/newPages/booking/components/TrafficInfoDialog.vue